import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import './BannerWhitepaper.scss';

function BannerWhitepapper() {
  return (
    <>
      <Container className='whitepapper-banner'>
        <Row className="text-white text-fs-head-xs">
          <Col>Home / Whitepaper</Col>
        </Row>
        <Row className="text-white text-fs-title-md mt-4">
          <Col lg={12} md={12}>
            Whitepaper
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default BannerWhitepapper;
